<template>
  <div class="jin-pc-index jin-pc jin-pc-height">
    <Pvideo />
    <div class="jin-pc-container jin-index-con">
      <Common />
    </div>
    <Product />
    <Welfare />
    <Activity />
    <JoinUs />
  </div>
</template>

<script>
import Common from './common'
import Product from './product'
import Welfare from './welfare'
import Activity from './activity'
import JoinUs from './joinUs'
export default {
  components: {
    Common,
    Product,
    Welfare,
    Activity,
    JoinUs
  },
  data() {
    return {
    }
  },
  mounted() {
    const welfareElTop = document.querySelector('.jin-welfare-title').getBoundingClientRect().top
    sessionStorage.setItem('welfareElTop', welfareElTop)
  }
}
</script>

<style lang="scss" scoped>
.jin {
  &-pc {
    &-index {
      background: rgba(19, 20, 21, .5);
      // background-image: url('~@/assets/index/back.png');
      background-repeat: no-repeat;
      background-size: cover;
      // overflow-x: hidden;
    }
  }

  /deep/ &-index {
    &-con {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: $bodyHeight;
    }

    &-title {
      h1 {
        line-height: 69px;
        font-size: 48px;
        margin-bottom: 20px;
      }

      p {
        letter-spacing: 16px;

        &::before,
        &::after {
          width: 92px;
          height: 10px;
        }

        &::before {
          left: calc(80px - 16px);
        }

        &::after {
          right: 80px;
        }
      }
    }

    &-search {
      width: 540px;
      height: 60px;
      margin-top: 80px;

      .el-input {
        input {
          box-shadow: 0 6px 12px 0 rgba(236, 239, 249, 0.26);
          border-radius: 30px;
        }
      }

      p {
        box-sizing: border-box;
        border-radius: 30px;
        font-size: 18px;
        padding-left: 24px;
      }

      span {
        right: 5px;
        width: 50px;
        height: 50px;

        i {
          font-size: 24px;
        }
      }
    }

    &-desc {
      margin-top: 70px;
      width: 492px;

      p {
        font-size: 14px;
        line-height: 30px;
      }

      p:nth-of-type(1) {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
